import { Component } from '@angular/core';
import { soundpostTrialBalanceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Trial Balances') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundposttrialbalance-form',
    templateUrl: './soundposttrialbalance.form.component.html'
})
export class soundpostTrialBalanceFormComponent extends BaseFormComponent {
    public record!: soundpostTrialBalanceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

